<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="input-group"
    role="group"
    :class="cn(
      'group/input-group relative flex w-full items-center outline-none font-ds',
      // Matches DSInput: card fill, ds radius, 40px.
      'bg-card border border-input rounded-ds-md',
      'transition-[border-color,box-shadow] duration-ds-fast ease-ds-standard',
      'h-10 min-w-0 has-[>textarea]:h-auto',

      // Variants based on alignment.
      'has-[>[data-align=inline-start]]:[&>input]:pl-2',
      'has-[>[data-align=inline-end]]:[&>input]:pr-2',
      'has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3',
      'has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3',

      // Focus state.
      // The group is the control, so the ring is the group's. shadcn uses a
      // ring + offset; @ds uses the Iris box-shadow and a border shift.
      'has-[[data-slot=input-group-control]:focus-visible]:border-ring',
      'has-[[data-slot=input-group-control]:focus-visible]:shadow-ds-focus',

      props.class,
    )"
  >
    <slot />
  </div>
</template>
